import { Field, Form, Formik } from "formik"
import React, { useState } from "react"
import { IStepTwo } from "./interface"
import { ButtonContainer, ColumnForTwoInputs, InputContainer, RadioButtonContainer, RadioButtonContent, RadioButtonDescription, RadioButtonForm, RowForButton, RowForInput, RowForTwoInput, TitleField } from "./style"
import InputMasked from "react-input-mask";
import Input from "../../Input";
import axios from "axios";
import api from "../../../service/api";
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { useDispatch, useSelector } from "react-redux";
import { ownerBranchs } from "../../../redux/actions/branchs";
import Button from "../../Button";
import * as Yup from "yup";
import MsgErrorInput from "../../MsgErrorInput";
import { cepObject } from "../../../service/cepDetail";
import { CepDetailInterface } from "../../../service/interfaces/cepDetail";

const StepTwo = (props: IStepTwo) => {
    const login = useSelector((state: {login: any}) => state.login);
    const dispatch = useDispatch();
    const clientType = props.clientType;
    const [addMessageError, setAddMessageError] = useState(false);
    const [isSameAddress, setIsSameAddress] = useState(false)
    const [cepDetailOwner, setCepDetailOwner] = useState<CepDetailInterface>(cepObject);
    const physicalPerson = 0;
    const legalPerson = 1;

    const handleCepDetailResultOwner = async (cep: string) => {
        const cepNumberWithoutHash = cep.split("-").join("");
        const {data} = await axios.get(`https://viacep.com.br/ws/${cepNumberWithoutHash}/json/`);
        
        setCepDetailOwner(data);
    } 

    const formValidationYup = Yup.object().shape({
        phoneNumber: Yup.string().required("*Obrigatório").min(15,"*Quantidade de dígitos inválido"),
        birthDay: Yup.string().required("*Obrigatório").min(10, "*Data inválida"),
        document: Yup.string().required("*Obrigatório").min(13, "*Quantidade de dígitos inválido"),
        businessName: clientType === legalPerson ? Yup.string().nullable(true) : Yup.string().required("*Obrigatório"),
        codePostalOwner: clientType === legalPerson ? Yup.string().required("*Obrigatório") : Yup.string().nullable(true),
        stateOwner: clientType === legalPerson ? Yup.string().required("*Obrigatório") : Yup.string().nullable(true),
        cityOwner: clientType === legalPerson ? Yup.string().required("*Obrigatório") : Yup.string().nullable(true),
        neighborhoodOwner: clientType === legalPerson ? Yup.string().required("*Obrigatório") : Yup.string().nullable(true),
        addressOwner: clientType === legalPerson ? Yup.string().required("*Obrigatório") : Yup.string().nullable(true),
        addressNumberOwner: clientType === legalPerson ? Yup.string().required("*Obrigatório") : Yup.string().nullable(true),
        firstName: clientType === legalPerson ? Yup.string().required("*Obrigatório") : Yup.string().nullable(true),
        lastName: clientType === legalPerson ? Yup.string().required("*Obrigatório") : Yup.string().nullable(true),
    })

    return (
        <Formik
        initialValues={{
            phoneNumber: "",
            birthDay: "",
            document: "",
            codePostalOwner: "",
            stateOwner: "",
            complementOwner: "",
            cityOwner: "",
            neighborhoodOwner: "",
            addressOwner: "",
            addressNumberOwner: "",
            firstName: "",
            lastName: "",
            businessName: "",
        }}
        validationSchema={formValidationYup}
        onSubmit={async (values) => {
            toastCreate("submit", "info" , 1000, "Dados processados...");
            
            if(clientType === physicalPerson){ // Pessoa física
                const phoneNumber = values.phoneNumber.replace("(", "").replace(")", "").replace("-", "").replace(" ", "");
                const cep = props.data.postalCode.replace("-", "");
                const cpf = values.document.replaceAll(".", "").replace("/", "").replace("-", "");
                let birthDay: Array<string> | string = values.birthDay.split("/");
                
                birthDay = `${birthDay[2]}-${birthDay[1]}-${birthDay[0]}`;
                
                try {
                    const dataPost = await api.post("/adm/ownerbranch/create", {
                        firstName: props.data.businessName,
                        lastName: props.data.businessCategory,
                        businessName: props.data.description,
                        businessCategory: props.data.businessCategory,
                        businessEmail: props.data.email,
                        businessPhone: phoneNumber,
                        phone: phoneNumber,
                        taxpayerIdBranch: cpf,
                        birthdate: birthDay,  
                        businessDescription: props.data.description,
                        description: null,
                        address: props.data.address,
                        number: props.data.addressNumber.toString(),
                        complement: props.data.complement,
                        neighborhood: props.data.neighborhood,
                        city: props.data.city,
                        state: props.data.uf,
                        codePostal: cep,
                        merchantCode: props.data.mmc,
                        ein: null,
                        apiOwnerId: "ddfa1503-7b41-49da-af40-882a4e946213",
                        background: null,
                        marketplaceId: login.user.owners.marketplaceId,
                        resource:"seller",
                        status:"enabled",
                        sellerOwner100PayId: login.user.owners.id,
                        standardLogo: null,   
                        type:"Seller",
                        translucidLogobackground: null,
                        primaryColor: props.data.primaryColor,
                        secundaryColor: props.data.secundaryColor,
                        businessWebSite: props.data.businessWebSite,
                        businessInstagram: props.data.businessInstagram,
                        businessFacebook: props.data.businessFacebook,
                        businessTwitter: props.data.businessTwitter,
                    });
                    
                    props.setEstablishmentId("dataPost.data.sellerOwnerPayId");
                    props.setStep(2);
                    setAddMessageError(false);
                    localStorage.setItem("addEstablishment", JSON.stringify(
                        {
                        step: 2,
                        sellerOwnerPayId: dataPost.data.sellerOwnerPayId,
                        fantasyName: props.data.description,
                        clientType: physicalPerson,
                        doc: cpf
                        }
                    ))
                    props.setData({
                        step: 2,
                        sellerOwnerPayId: dataPost.data.sellerOwnerPayId,
                        fantasyName: props.data.description,
                        clientType: physicalPerson,
                        doc: cpf
                    })
                    const {data} = await api.get("/adm/owner100pay/list", {
                        params: {
                        id: login.user.owners.id
                        }
                    });
            
                    const branchsFoundeds = [...data.Branch];
                    
                    dispatch(ownerBranchs(branchsFoundeds));
                    toastUpdate("submit", "success" , 3000, "Estabelecimento adicionado")
                } catch (error) {
                    setAddMessageError(true);
                    toastUpdate("submit", "error" , 3000, "Erro ao adicionar estabelecimento")
                }
              } else if (clientType === legalPerson){ // Pessoa jurídica
                const phoneNumber = values.phoneNumber.replace("(", "").replace(")", "").replace("-", "").replace(" ", "");
                const phoneNumberBusiness = props.data.businessPhone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "");
                
                const cep = props.data.postalCode.replace("-", "");
                const cepOwner = values.codePostalOwner.replace("-", "");

                const cpf = values.document.replaceAll(".", "").replace("/", "").replace("-", "");
                const cnpj = props.data.ein.replaceAll(".", "").replace("/", "").replace("-", "");
                
                let birthDay: Array<string> | string = values.birthDay.split("/");
                let openingDate: Array<string> | string = props.data.businessOpeningDate.split("/");
                
                birthDay = `${birthDay[2]}-${birthDay[1]}-${birthDay[0]}`;
                openingDate = `${openingDate[2]}-${openingDate[1]}-${openingDate[0]}`;
                
                try {
                    const dataPost = await api.post("/adm/ownerbranch/create", {
                        firstName: values.firstName,
                        lastName: values.lastName,
                        businessEmail: props.data.email,
                        phone: phoneNumber,
                        taxpayerIdBranch: cpf,
                        birthdate: birthDay,
                        businessDescription: props.data.description,
                        businessName: props.data.name,
                        businessPhone: phoneNumberBusiness,
                        businessWebSite: props.data.businessWebSite,
                        businessFacebook: props.data.businessFacebook,
                        businessTwitter: props.data.businessTwitter,
                        ein: cnpj,
                        businessAddress: props.data.address,
                        businessNumber: props.data.addressNumber.toString(),
                        businessComplement: props.data.complement,
                        businessNeighborhood: props.data.neighborhood,
                        businessCity: props.data.city,
                        businessState: props.data.uf,
                        businessCodePostal: cep,
                        businessOpeningDate: openingDate,
                        businessCategory: props.data.businessCategory,
                        address: isSameAddress ? props.data.address : values.addressOwner,
                        number: isSameAddress ? props.data.addressNumber.toString() : values.addressNumberOwner.toString(),
                        neighborhood: isSameAddress ? props.data.neighborhood : values.neighborhoodOwner,
                        complement: isSameAddress ? props.data.complement : values.complementOwner,
                        city: isSameAddress ? props.data.city : values.cityOwner,
                        state: isSameAddress ? props.data.uf : values.stateOwner,
                        codePostal: isSameAddress ? cep : cepOwner,
                        merchantCode: props.data.mmc,
                        apiOwnerId: "ddfa1503-7b41-49da-af40-882a4e946213",
                        background: null,
                        marketplaceId: login.user.owners.marketplaceId,
                        resource:"seller",
                        status:"enabled",
                        sellerOwner100PayId: login.user.owners.id,
                        standardLogo: null,   
                        type:"Seller",
                        translucidLogobackground: null,
                        primaryColor: props.data.primaryColor,
                        secundaryColor: props.data.secundaryColor,
                        businessInstagram: props.data.businessInstagram,
                    });

                    props.setEstablishmentId("dataPost.data.sellerOwnerPayId");
                    props.setStep(2);
                    setAddMessageError(false);
                    localStorage.setItem("addEstablishment", JSON.stringify(
                        {
                        step: 2,
                        sellerOwnerPayId: dataPost.data.sellerOwnerPayId,
                        fantasyName: props.data.description,
                        clientType: legalPerson,
                        doc: props.data.ein
                        }
                    ))
                    props.setData({
                        step: 2,
                        sellerOwnerPayId: dataPost.data.sellerOwnerPayId,
                        fantasyName: props.data.description,
                        clientType: legalPerson,
                        doc: props.data.ein
                    })
                    const {data} = await api.get("/adm/owner100pay/list", {
                        params: {
                        id: login.user.owners.id
                        }
                    });
            
                    const branchsFoundeds = [...data.Branch];
                    
                    dispatch(ownerBranchs(branchsFoundeds));
                    toastUpdate("submit", "success" , 3000, "Estabelecimento adicionado")
                } catch (error) {
                    setAddMessageError(true);
                    toastUpdate("submit", "error" , 3000, "Erro ao adicionar estabelecimento")
                }
              }
        }}
        >
            {({values, errors, touched, handleChange, isValid, dirty}) => {
                if (clientType === legalPerson) {
                    values.cityOwner = cepDetailOwner.localidade;
                    values.stateOwner = cepDetailOwner.uf;
                    values.neighborhoodOwner = cepDetailOwner.bairro;
                    values.addressOwner = cepDetailOwner.logradouro;
                }
                
                if(isSameAddress) {
                    values.codePostalOwner = props.data.postalCode
                    values.cityOwner = props.data.city;
                    values.stateOwner = props.data.uf;
                    values.neighborhoodOwner = props.data.neighborhood;
                    values.addressOwner = props.data.address;
                    values.addressNumberOwner = props.data.addressNumber;
                    values.complementOwner = props.data.complement
                }
                
                return (
                    <Form>
                        <TitleField>Dados do proprietário</TitleField>
                            {
                            clientType === legalPerson
                            ? <>
                                <RowForInput>
                                    <InputContainer>
                                        <Field id="firstName" name="firstName" placeholder="Primeiro nome" 
                                            style={{borderColor: `${touched.firstName && errors.firstName ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            as={Input}
                                        />
                                        {touched.firstName && errors.firstName ? <MsgErrorInput style={{top: 30}}>{ errors.firstName }</MsgErrorInput> : null }
                                    </InputContainer>
                                    <InputContainer>
                                        <Field id="lastName" name="lastName" placeholder="Último nome" 
                                            style={{borderColor: `${touched.lastName && errors.lastName ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            as={Input}
                                        />
                                        {touched.lastName && errors.lastName ? <MsgErrorInput style={{top: 30}}>{ errors.lastName }</MsgErrorInput> : null }
                                    </InputContainer>
                                </RowForInput>
                            </>
                            : <RowForInput>
                                <InputContainer>
                                    <Field id="businessName" name="businessName" placeholder="Nome completo" 
                                        style={{borderColor: `${touched.businessName && errors.businessName ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        as={Input}
                                    />
                                    {touched.businessName && errors.businessName ? <MsgErrorInput style={{top: 30}}>{ errors.businessName }</MsgErrorInput> : null }
                                </InputContainer>
                                <InputContainer>
                                    <Field 
                                        name="phoneNumber" 
                                        id="phoneNumber" 
                                        placeholder="Telefone do proprietário" 
                                        style={{borderColor: `${touched.phoneNumber && errors.phoneNumber ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        mask="(99) 99999-9999"
                                        className="input-masked"
                                        maskChar={null}
                                        value={values.phoneNumber}
                                        onChange={(e: any) => handleChange(e)}
                                        as={InputMasked}
                                    />
                                    {touched.phoneNumber && errors.phoneNumber ? <MsgErrorInput style={{top: 30}}>{ errors.phoneNumber }</MsgErrorInput> : null }
                                </InputContainer>
                            </RowForInput>
                        }

                        <RowForInput>
                            <InputContainer>
                                <Field name="birthDay"
                                    id="birthDay"
                                    placeholder="Data de nascimento"
                                    style={{borderColor: `${touched.birthDay && errors.birthDay ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                    className="input-masked"
                                    mask="99/99/9999"
                                    maskChar={null}
                                    value={values.birthDay}
                                    onChange={(e: any) => handleChange(e)}
                                    as={InputMasked}
                                />
                                {touched.birthDay && errors.birthDay ? <MsgErrorInput style={{top: 30}}>{ errors.birthDay }</MsgErrorInput> : null }
                            </InputContainer>
                            <InputContainer>
                                <Field  name="document"
                                    id="document"
                                    placeholder={"CPF"}
                                    style={{borderColor: `${touched.document && errors.document ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                    className="input-masked"
                                    maskChar={null}
                                    mask={"999.999.999-99"}
                                    value={values.document}
                                    onChange={(e: any) => handleChange(e)}  
                                    as={Input}
                                />
                                {touched.document && errors.document ? <MsgErrorInput style={{top: 30}}>{ errors.document }</MsgErrorInput> : null }
                            </InputContainer>
                        </RowForInput>

                        {
                            clientType === legalPerson
                            ? <RowForInput>
                                <InputContainer>
                                    <Field 
                                        name="phoneNumber" 
                                        id="phoneNumber" 
                                        placeholder="Telefone do proprietário" 
                                        style={{borderColor: `${touched.phoneNumber && errors.phoneNumber ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        mask="(99) 99999-9999"
                                        className="input-masked"
                                        maskChar={null}
                                        value={values.phoneNumber}
                                        onChange={(e: any) => handleChange(e)}
                                        as={InputMasked}
                                    />
                                    {touched.phoneNumber && errors.phoneNumber ? <MsgErrorInput style={{top: 30}}>{ errors.phoneNumber }</MsgErrorInput> : null }
                                </InputContainer>
                            </RowForInput> 
                            : null
                        }

                        {
                            clientType === legalPerson
                            ? <>
                            <TitleField>Endereço do proprietário</TitleField>
                        
                            <RowForInput>
                            <InputContainer className="d-flex justify-content-between" style={{width: "70%"}}>
                            <RadioButtonForm onClick={() => {
                                setIsSameAddress(true);  
                                }}>
                                    <RadioButtonContainer>
                                        <RadioButtonContent isPrimary={isSameAddress === true}/>
                                    </RadioButtonContainer>
                                    <RadioButtonDescription>Usar mesmo endereço da empresa</RadioButtonDescription>
                                </RadioButtonForm>

                                <RadioButtonForm onClick={() => {
                                setIsSameAddress(false);
                                }}>
                                    <RadioButtonContainer>
                                        <RadioButtonContent isPrimary={isSameAddress === false}/>
                                    </RadioButtonContainer>
                                    <RadioButtonDescription>Usar endereço diferente</RadioButtonDescription>
                                </RadioButtonForm>
                            </InputContainer>
                            </RowForInput>
                            {
                            isSameAddress ?
                            null
                            : <>
                                <RowForInput>
                                <InputContainer>
                                    <Field name="codePostalOwner"
                                        id="codePostalOwner"
                                        placeholder="CEP"
                                        className="input-masked"
                                        mask="99999-999"
                                        style={{borderColor: `${touched.codePostalOwner && errors.codePostalOwner ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        maskChar={null}
                                        value={values.codePostalOwner}
                                        onKeyUp={async () => {
                                            if(values.codePostalOwner.length === 9){
                                                handleCepDetailResultOwner(values.codePostalOwner);
                                            }
                                        }}
                                        onChange={(e: any) => handleChange(e)}
                                        as={InputMasked}
                                    />
                                    {touched.codePostalOwner && errors.codePostalOwner ? <MsgErrorInput style={{top: 30}}>{ errors.codePostalOwner }</MsgErrorInput> : null }
                                </InputContainer>

                                <ColumnForTwoInputs>
                                    <RowForTwoInput>
                                    <InputContainer style={{width: "65%"}}>
                                        <Field 
                                            id="cityOwner" name="cityOwner" placeholder="Cidade" 
                                            onChange={(e: any) => {
                                                handleChange(e);
                                                setCepDetailOwner({...cepDetailOwner, localidade: e.target.value})
                                            }}
                                            style={{borderColor: `${touched.cityOwner && errors.cityOwner ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            as={Input}
                                        />
                                        {touched.cityOwner && errors.cityOwner ? <MsgErrorInput style={{top: 30}}>{ errors.cityOwner }</MsgErrorInput> : null }
                                    </InputContainer>
                                    <InputContainer style={{width: "30%"}}>
                                        <Field 
                                        name="stateOwner"
                                        >
                                        {() => (
                                            <InputMasked
                                                id="stateOwner" 
                                                placeholder="UF" 
                                                style={{borderColor: `${touched.stateOwner && errors.stateOwner ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                className="input-masked"
                                                maskChar={null}
                                                mask="aa"
                                                value={values.stateOwner}
                                                onChange={(e: any) => {
                                                    handleChange(e);
                                                    setCepDetailOwner({...cepDetailOwner, uf: e.target.value})
                                                }}
                                            />
                                        )}
                                        </Field>
                                        {touched.stateOwner && errors.stateOwner ? <MsgErrorInput style={{top: 30}}>{ errors.stateOwner }</MsgErrorInput> : null }
                                        </InputContainer>
                                    </RowForTwoInput>
                                    </ColumnForTwoInputs>
                                </RowForInput>

                                <RowForInput>
                                <InputContainer>
                                    <Field 
                                        id="addressOwner" name="addressOwner"  placeholder="Endereço" 
                                        onChange={(e: any) => {
                                            handleChange(e);
                                            setCepDetailOwner({...cepDetailOwner, logradouro: e.target.value})
                                        }}
                                        style={{borderColor: `${touched.addressOwner && errors.addressOwner ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        as={Input}
                                    />
                                    {touched.addressOwner && errors.addressOwner ? <MsgErrorInput style={{top: 30}}>{ errors.addressOwner }</MsgErrorInput> : null }
                                </InputContainer>
                                <InputContainer>
                                    <Field id="neighborhoodOwner" name="neighborhoodOwner" placeholder="Bairro"
                                        onChange={(e: any) => {
                                            handleChange(e);
                                            setCepDetailOwner({...cepDetailOwner, bairro: e.target.value})
                                        }}
                                        style={{borderColor: `${touched.neighborhoodOwner && errors.neighborhoodOwner ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        as={Input}
                                    />
                                    {touched.neighborhoodOwner && errors.neighborhoodOwner ? <MsgErrorInput style={{top: 30}}>{ errors.neighborhoodOwner }</MsgErrorInput> : null }
                                </InputContainer>
                                </RowForInput>

                                <RowForInput>
                                <InputContainer>
                                    <Field id="addressNumberOwner" name="addressNumberOwner" placeholder="Número" 
                                        style={{borderColor: `${touched.addressNumberOwner && errors.addressNumberOwner ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        as={Input}
                                    />
                                    {touched.addressNumberOwner && errors.addressNumberOwner ? <MsgErrorInput style={{top: 30}}>{ errors.addressNumberOwner }</MsgErrorInput> : null }
                                </InputContainer>
                                <InputContainer>
                                    <Field id="complementOwner" name="complementOwner" placeholder="Complemento" 
                                        style={{borderColor: `${touched.complementOwner && errors.complementOwner ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        as={Input}
                                    />
                                    {touched.complementOwner && errors.complementOwner ? <MsgErrorInput style={{top: 30}}>{ errors.complementOwner }</MsgErrorInput> : null }
                                </InputContainer>
                                </RowForInput>
                            </>}
                            </>
                            : null
                        }
                        <RowForButton>
                            <ButtonContainer>
                                {
                                    addMessageError
                                    ? <MsgErrorInput>
                                        Erro ao adicionar estabelecimento
                                    </MsgErrorInput>
                                    : null
                                }
                                <Button
                                    type="submit"
                                    disabled={!(dirty && isValid)}
                                >
                                    Enviar
                                </Button>
                            </ButtonContainer>
                        </RowForButton>
                    </Form>
                )
            }}
        </Formik>
    )
}

export default StepTwo